import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import type { DeleteSeasonResponse, SeasonsListResponse } from "../../types/gamePass";
import { getPrivateInstance } from "../_privateInstance";

const buildDeleteSeasonUrl = (seasonId: string): string =>
  API_ROUTES.DELETE_SEASON.replace("{season_id}", seasonId);

const deleteSeason = async (seasonId: string): Promise<string> => {
  await getPrivateInstance().delete<DeleteSeasonResponse>(
    buildDeleteSeasonUrl(seasonId),
  );
  return seasonId;
};

export const useDeleteSeason = (): UseMutationResult<string, Error, string> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["game-pass", "seasons", "delete"],
    mutationFn: deleteSeason,
    onSuccess: (seasonId) => {
      queryClient.setQueriesData<SeasonsListResponse>(
        { queryKey: ["game-pass", "seasons", "list"] },
        (current) => {
          if (!current) return current;
          return {
            ...current,
            seasons: current.seasons.filter(
              (record) => (record.id ?? record.season_id) !== seasonId,
            ),
          };
        },
      );
      queryClient.invalidateQueries({
        queryKey: ["game-pass", "seasons", "list"],
      });
    },
  });
};
